module.exports = __webpack_public_path__ + "img/6117e8e.png";